<template>
  <div style="padding: 20px">
    <el-button style="margin-bottom: 20px" @click="create" type="primary" size="small">新增</el-button>
    <el-table
        :data="tableData"
        border
        style="width: 100%">
      <el-table-column
          prop="date"
          label="时间"
          width="180">
      </el-table-column>
      <el-table-column
          prop="cover"
          label="封面"
          width="180">
        <template slot-scope="scope">
          <el-image  style="width: 100px; height: 100px" :src="scope.row.cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column
          prop="content"
          label="内容">
        <template slot-scope="scope">
          <div v-html="scope.row.content"></div>
        </template>
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          width="100">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <news-form ref="form" @save="save"></news-form>
  </div>
</template>

<script>
import NewsForm from "@/components/admin/news/NewsForm";
import {
  deleteNews,
  getNews,
  insertNews,
  updatetNews,
} from "@/api/api";
export default {
  name: "NewsTable",
  components: {NewsForm},
  props:['lang'],
  watch:{
    lang(){
      this.init();
    }
  },
  data(){
    return {
      tableData:[],
      type:'news'
    }
  },
  mounted() {
    this.init()
  },
  computed:{
    fileName(){
      return `${this.type}_${this.lang}.json`
    }
  },
  methods:{
    init(){
      getNews().then(res => {
        if(res.data.code !== 500 ) {
          this.tableData = res.data.data;
        }
      })
    },
    save(newData){
      this.loading = true;
      let action = newData.id ? updatetNews(newData) : insertNews(newData)
      action.then(res => {
        if(res.data.code === 200 ) {
          this.$message.success(res.data.msg)
          this.init();
          this.loading = false;
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    create(){
      this.$refs.form.open({})
    },
    edit(row){
      this.$refs.form.open(row)
    },
    del(row){
      deleteNews(row).then(res => {
        if(res.data.code === 200 ) {
          this.$message.success(res.data.msg)
          this.init();
          this.loading = false;
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
